import CONSTANTS from '~/constants'

export default {
  type: 'story',
  title: `Story Reference`,
  icon: `newspaper-o`,
  template: (config) => `<div
        class="p-2"
        style="background-color: #f2f2f2"
        contenteditable="false"
        org-index="orgIndex"
        data-index="${config.index}"
        ng-model="feature.content">
        <h2>Story Reference</h2>
        <dl class="row">
          <dt class="col-sm-3">Headline</dt>
          <dd class="col-sm-9">{{feature.headlines.basic || "No Headline"}}</dd>
          <dt class="col-sm-3">Sub-Headline</dt>
          <dd class="col-sm-9">{{feature.subheadlines.basic || "No Sub Headline"}}</dd>
          <dt class="col-sm-3" ng-show="feature.slug.length">Slug</dt>
          <dd class="col-sm-9">{{feature.slug}}</dd>
          <dt class="col-sm-3" ng-show="feature.planning.budget_line.length">Budget</dt>
          <dd class="col-sm-9">{{feature.planning.budget_line}}</dd>
        </dl>
    </div>`,
  preview: function (feature) {
    const storyId = feature._id
    if (storyId) {
      window.open(`${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/story/${storyId}/`)
    }
  },
}
